<template>
  <div class="catches-admin container">
    <div class="is-pulled-right">
      <nav
        v-if="competition"
        class="breadcrumb"
        aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/">
              Top
            </router-link>
          </li>
          <li
            :class="{ 'is-active': !day}">
            <router-link :to="'/edit/competition/' + competition.pk">
              {{ competition.name }}
            </router-link>
          </li>
          <li
            v-if="day"
            :class="{ 'is-active': day}">
            <router-link
              to="#"
              aria-current="page">
              {{ day.name }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <h1
      v-if="competition"
      class="title">
      {{ competition.name }} - {{ day.name }}
    </h1>
    <section
      class="modal-card-body">
      <b-field grouped>
        <b-field
          :label="$gettext('Lagnummer')"
          label-position="on-border">
          <b-input
            ref="teamId"
            v-model="teamId"
            :autofocus="true"
            type="number"
            pattern="[0-9]+?"
            :placeholder="$gettext('Lagnummer')" />
        </b-field>
        <b-field
          :label="$gettext('Längd i cm')"
          label-position="on-border">
          <b-input
            v-model="length"
            type="string"
            pattern="[0-9]+([,\.][0-9]+)?"
            :placeholder="$gettext('Fångstens längd')" />
        </b-field>
        <b-field
          :label="$gettext('Vikt i kg')"
          label-position="on-border">
          <b-input
            v-model="weight"
            type="string"
            pattern="[0-9]+([,\.][0-9]+)?"
            :placeholder="$gettext('Fångstens vikt')"
            @keyup.native.enter="save" />
        </b-field>
        <button
          class="button is-primary"
          @click="save">
          <translate>Lägg till fångst</translate>
        </button>
      </b-field>
      <b-notification
        v-if="errorText"
        type="is-danger"
        has-icon
        :aria-close-label="$gettext('Close notification')"
        role="alert">
        {{ errorText }}
      </b-notification>
      <b-notification
        v-if="success"
        type="is-success"
        has-icon
        :aria-close-label="$gettext('Close notification')"
        role="alert">
        <translate>Fångsten sparad</translate>
      </b-notification>
    </section>
    <nav
      v-if="catches"
      class="panel">
      <p class="panel-heading">
        <translate>Fångster</translate>
      </p>
      <div
        v-for="(thiscatch, index) of sortedCatches"
        :key="index"
        class="panel-block">
        <p>
          {{ getTeamName(thiscatch.team, 'number') }} -
          {{ getTeamName(thiscatch.team, 'name') }} -
          {{ thiscatch.length.toLocaleString('fi-SV') }} cm /
          {{ thiscatch.weight.toLocaleString('fi-SV') }} kg
        </p>
        <div class="field is-pulled-right has-addons">
          <p class="control">
            <button
              v-if="loggedIn"
              class="button"
              @click="openModal(thiscatch.pk)">
              <translate>Ändra</translate>
            </button>
          </p>
          <p class="control">
            <button
              v-if="loggedIn"
              class="button is-danger"
              @click="openDeleteModal(thiscatch.pk)">
              <translate>Radera</translate>
            </button>
          </p>
        </div>
        <b-modal
          :active.sync="isComponentModalActive[thiscatch.pk]">
          <edit-catch :id="thiscatch.pk" />
        </b-modal>
        <b-modal
          :active.sync="isComponentDeleteModalActive[thiscatch.pk]">
          <delete-catch :id="thiscatch.pk" />
        </b-modal>
      </div>
    </nav>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  competitionService, dayService, teamService, catchService} from '../_services';
import EditCatch from '../components/catch/Edit'
import DeleteCatch from '../components/catch/Delete'

export default {
  name: 'CatchAdminPage',
  components: {
    EditCatch,
    DeleteCatch,
  },
  props: {
    id: {
      type: String,
      default: undefined,
    },
  },
  data () {
    return {
      competition: undefined,
      day: undefined,
      teams: undefined,
      catches: undefined,
      isComponentModalActive: [],
      isComponentDeleteModalActive: [],
      isComponentNewModalActive: false,
      teamId: undefined,
      team: undefined,
      weight: '',
      length: '',
      success: undefined,
      errorText: undefined,
    }
  },
  computed: {
    loggedIn () {
      return this.$store.state.authentication.status.loggedIn;
    },
    user () {
      return this.$store.state.authentication.token
    },
    sortedCatches: function() {
      function compare(a, b) {
        if (a.registration_time > b.registration_time)
          return -1;
        if (a.registration_time < b.registration_time)
          return 1;
        return 0;
      }
      // eslint-disable-next-line
      return this.catches.sort(compare);
    },
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetch'
  },
  created () {
    var self = this
    self.fetch()

  },
  methods: {
    async fetch() {
      var self = this
      try{
        self.day = await dayService.get(self.id)
        self.competition = await competitionService.get(self.day.competition)
        self.teams = await teamService.getAll(self.day.competition)
        self.catches = await catchService.getAll(self.id)
        self.$refs.teamId.focus()
      }catch(err){

        console.error('Caught error')
        console.error(err)
      }
    },
    save: async function(){
      var self = this
      try {
        self.team = self.getTeamFromNumber(self.teamId)
        const data =
          {
            day: self.day.pk,
            team: self.team.pk,
            length: parseFloat(self.length.replace(",", ".")),
            weight: parseFloat(self.weight.replace(",", ".")),
          }
        await catchService.post(data)
        self.catches = await catchService.getAll(self.id)
        self.success = true
        self.teamId = undefined
        self.length = undefined
        self.weight = undefined
      }catch(err){
        console.error(err)
        self.errorText = 'Felaktigt data'
      }
      setTimeout(() => {
        self.errorText = undefined
        self.success = undefined
      }, 3000);
      self.$refs.teamId.focus()
    },
    openModal: function(id){
      var self = this
      Vue.set(self.isComponentModalActive, id, true)
    },
    openDeleteModal: function(id){
      var self = this
      Vue.set(self.isComponentDeleteModalActive, id, true)
    },
    openNewModal: function(){
      var self = this
      self.isComponentNewModalActive = true
    },
    openTeamModal: function(id){
      var self = this
      Vue.set(self.isTeamModalActive, id, true)
    },
    openDeleteTeamModal: function(id){
      var self = this
      Vue.set(self.isTeamDeleteModalActive, id, true)
    },
    openNewTeamModal: function(){
      var self = this
      self.isTeamNewModalActive = true
    },
    getTeamFromNumber: function(search){
      var self = this
      try{
        return self.teams.find( ({ number }) => number == search )
      }catch(err){
        return 'Unknown'
      }
    },
    getTeamName: function(id, attribute){
      var self = this
      try{
        const team = self.teams.find( ({ pk }) => pk == id )
        if (attribute == 'name'){
          return team.name
        }
        if (attribute == 'number'){
          return team.number
        }

      }catch(err){
        return 'Unknown'
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-block {
  justify-content: space-between;
}
</style>
